import { NavLink, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LayoutDashboard, Flame, Sparkles, Compass, Inbox, LogOut, Globe, BarChart3 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Übersicht", icon: LayoutDashboard, testid: "nav-overview", end: true },
  { to: "/admin/analytics", label: "Statistiken", icon: BarChart3, testid: "nav-analytics" },
  { to: "/admin/deals", label: "Deals", icon: Flame, testid: "nav-deals" },
  { to: "/admin/submissions", label: "Einreichungen", icon: Inbox, testid: "nav-submissions" },
  { to: "/admin/content", label: "Content Studio", icon: Sparkles, testid: "nav-content" },
  { to: "/admin/niches", label: "Nischen-Finder", icon: Compass, testid: "nav-niches" },
];

export const Sidebar = () => {
  const { user, logout } = useAuth();
  return (
    <aside
      className="w-[260px] shrink-0 bg-[#F5F5F7] border-r border-black/5 h-screen sticky top-0 hidden md:flex flex-col"
      data-testid="app-sidebar"
    >
      <div className="px-6 py-7">
        <Logo markSize={38} />
      </div>

      <nav className="px-3 mt-2 flex flex-col gap-1">
        {NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              className={({ isActive }) =>
                `group relative flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-white text-[#1D1D1F] shadow-[0_1px_4px_rgba(0,0,0,0.06)]"
                    : "text-[#86868B] hover:text-[#1D1D1F] hover:bg-black/[0.03]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <motion.span
                      layoutId="sidebar-active"
                      className="absolute left-0 top-2 bottom-2 w-[3px] rounded-full ai-gradient-bg"
                    />
                  )}
                  <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
                  {item.label}
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="mt-auto p-4 space-y-3">
        <Link to="/" className="flex items-center gap-2 px-3.5 py-2.5 rounded-xl text-sm font-medium text-[#86868B] hover:text-[#1D1D1F] hover:bg-black/[0.03] transition-all" data-testid="nav-to-site">
          <Globe className="h-[18px] w-[18px]" strokeWidth={2} /> Zur Webseite
        </Link>
        <button onClick={logout} className="w-full flex items-center gap-2 px-3.5 py-2.5 rounded-xl text-sm font-medium text-rose-500 hover:bg-rose-50 transition-all" data-testid="admin-logout">
          <LogOut className="h-[18px] w-[18px]" strokeWidth={2} /> Abmelden
        </button>
        <div className="rounded-2xl border border-black/5 bg-white p-4 shadow-[0_2px_10px_rgba(0,0,0,0.02)]">
          <p className="text-xs font-semibold text-[#1D1D1F] mb-1">{user?.name || "Admin"}</p>
          <p className="text-[11px] leading-relaxed text-[#86868B]">
            Cockpit – Deals verwalten, freigeben & automatisieren.
          </p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
